import { getAxios } from "@coremind/identity-core";
/**
 * The App Store's real source of "which sites can this workspace even see" -- GET
 * /tenants/{tenant_id}/sites (TenantSiteMembership), not the site-wide public catalog. Per direct
 * instruction (2026-09-19): a site only shows up here once ops has made it available to the
 * workspace via the orgs portal's Workspace Sites page (or, later, a workspace-type template) --
 * the App Store itself never grants that, it only lets the user pin an already-available site to
 * their own menu (see useSiteMenu.ts). Filtered to sites with real catalog metadata
 * (membershipModel is only set for App-Store-curated sites) so a workspace's own home-site link
 * or other internal-only membership rows don't show up as storefront cards.
 */
export async function listWorkspaceCatalogSites(tenantId) {
    const res = await getAxios().get(`/tenants/${tenantId}/sites`);
    return (res.data ?? []).filter((s) => !!s.membershipModel);
}
